module.exports = __webpack_public_path__ + "static/media/renata-olejniczak.fd5c4528.png";